(() => {
  const body = document.body;
  if (!body) return;

  const READY_CLASS = 'page-is-ready';
  const LEAVING_CLASS = 'page-is-transitioning';

  const markReady = () => {
    window.requestAnimationFrame(() => {
      body.classList.add(READY_CLASS);
      body.classList.remove(LEAVING_CLASS);
    });
  };

  const isSamePageAnchor = (url) =>
    url.origin === window.location.origin &&
    url.pathname === window.location.pathname &&
    url.search === window.location.search &&
    url.hash.length > 0;

  const bumpElements = (elements, className) => {
    elements
      .filter(Boolean)
      .forEach((element, index) => {
        element.classList.remove(className);
        void element.offsetWidth;
        element.classList.add(className);

        window.setTimeout(() => {
          element.classList.remove(className);
        }, 520 + index * 40);
      });
  };

  const initPageTransitions = () => {
    markReady();

    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href]');
      if (!link || event.defaultPrevented) return;
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (link.target && link.target !== '_self') return;
      if (link.hasAttribute('download')) return;

      const href = link.getAttribute('href') || '';
      if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('javascript:')) return;

      const url = new URL(link.href, window.location.origin);
      if (url.origin !== window.location.origin || isSamePageAnchor(url)) return;

      body.classList.add(LEAVING_CLASS);
    });

    window.addEventListener('beforeunload', () => {
      body.classList.add(LEAVING_CLASS);
    });

    window.addEventListener('pageshow', () => {
      markReady();
    });
  };

  const initCartAnimations = () => {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      bumpElements(
        Array.from(document.querySelectorAll('#cart-icon-bubble, .cart-count-bubble, .header__icon--cart')),
        'is-bumping'
      );

      bumpElements(
        Array.from(document.querySelectorAll('cart-items .cart-item, cart-drawer-items .cart-item')).slice(0, 6),
        'is-cart-highlighted'
      );

      bumpElements(
        Array.from(document.querySelectorAll('#main-cart-footer .cart__blocks, .cart__warnings')).slice(0, 2),
        'is-cart-highlighted'
      );
    });
  };

  const initYampiCartCheckout = () => {
    const button = document.querySelector('[data-rabel-yampi-checkout]');
    if (!button) return;

    const note = document.querySelector('[data-rabel-yampi-note]');
    const supportLink = document.querySelector('[data-rabel-yampi-support]');
    const defaultLabel = button.dataset.defaultLabel || button.textContent.trim();
    const loadingLabel = button.dataset.loadingLabel || defaultLabel;
    const cartEndpoint = 'https://api.dooki.com.br/v2/public/shopify/cart';
    const internalDomain = window.Shopify?.shop || '';

    let isBusy = false;
    let cachedUrl = window.yampiCheckoutUrl || '';

    const setMessage = (message, showSupport = false) => {
      if (note) {
        note.hidden = !message;
        note.textContent = message || '';
      }

      if (supportLink) {
        supportLink.hidden = !showSupport;
      }
    };

    const setBusy = (busy) => {
      isBusy = busy;
      button.disabled = busy;
      button.classList.toggle('is-loading', busy);
      button.setAttribute('aria-busy', busy ? 'true' : 'false');
      button.textContent = busy ? loadingLabel : defaultLabel;
    };

    const getCartPayload = async () => {
      const response = await fetch('/cart.json', {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });

      if (!response.ok) {
        throw new Error('Nao foi possivel carregar o carrinho.');
      }

      return response.json();
    };

    const buildPayloads = (cartPayload) => {
      const shops = Array.from(new Set([window.location.host, internalDomain].filter(Boolean)));
      const payloads = [];

      shops.forEach((shop) => {
        payloads.push({ shop, cart_payload: cartPayload });

        if (internalDomain) {
          payloads.push({ shop, shopify_internal_domain: internalDomain, cart_payload: cartPayload });
        }
      });

      return payloads;
    };

    const requestCheckoutUrl = async () => {
      const cartPayload = await getCartPayload();

      if (!cartPayload.item_count) {
        return { empty: true };
      }

      let lastResponse = null;

      for (const payload of buildPayloads(cartPayload)) {
        const response = await fetch(cartEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify(payload),
        });

        if (!response.ok) continue;

        const data = await response.json();
        lastResponse = data;

        if (data.checkout_direct_url) {
          cachedUrl = data.checkout_direct_url;
          window.yampiCheckoutUrl = data.checkout_direct_url;
          return { url: data.checkout_direct_url, data };
        }
      }

      return { url: '', data: lastResponse };
    };

    const goToCheckout = (url) => {
      if (!url) return;
      window.location.href = url;
    };

    const primeCheckout = async () => {
      if (cachedUrl) return;

      try {
        const result = await requestCheckoutUrl();
        if (result.url) {
          setMessage('');
        }
      } catch (error) {
        // Keep the button interactive and retry on click.
      }
    };

    button.addEventListener('click', async () => {
      if (isBusy) return;

      setMessage('');

      if (cachedUrl || window.yampiCheckoutUrl) {
        goToCheckout(cachedUrl || window.yampiCheckoutUrl);
        return;
      }

      setBusy(true);

      try {
        const result = await requestCheckoutUrl();

        if (result.url) {
          goToCheckout(result.url);
          return;
        }

        if (result.empty) {
          setMessage('Seu carrinho esta vazio no momento.');
        } else {
          setMessage(
            'Nao foi possivel iniciar o checkout online para este item agora. Fale conosco no WhatsApp para concluir.',
            true
          );
        }
      } catch (error) {
        setMessage(
          'O checkout online nao respondeu agora. Fale conosco no WhatsApp para concluir.',
          true
        );
      } finally {
        setBusy(false);
      }
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        cachedUrl = '';
        window.yampiCheckoutUrl = '';
        setMessage('');
        button.disabled = false;
        button.classList.remove('is-loading');
        button.textContent = defaultLabel;
        window.setTimeout(() => {
          void primeCheckout();
        }, 350);
      });
    }

    void primeCheckout();
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initPageTransitions();
        initCartAnimations();
        initYampiCartCheckout();
      },
      { once: true }
    );
  } else {
    initPageTransitions();
    initCartAnimations();
    initYampiCartCheckout();
  }
})();
